import styles from "./search-input.module.less";

export type TSearchInput = {
  value?: string;
  placeholder?: string;
  icon?: string;
  className?: string;
  inputReference?: React.RefObject<HTMLInputElement>;
  hasError: boolean;
  onChange?: (searchTerm: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const SearchInput = ({
  value,
  placeholder,
  icon,
  className,
  inputReference,
  hasError,
  onChange,
  onFocus,
  onBlur,
}: TSearchInput) => {
  const onChangeLocal = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const onClickIcon = () => {
    if (value && value.length > 0) {
      if (typeof onChange === "function") {
        onChange("");
      }
      if (inputReference && inputReference.current) {
        inputReference.current.focus();
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <input
        autoFocus={true}
        ref={inputReference}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChangeLocal}
        value={value}
        className={[styles.input, "h5", className, hasError ? styles.error : ""].join(" ")}
        placeholder={placeholder}
      />
      {icon && (
        <button
          onClick={onClickIcon}
          className={[
            styles.icon,
            hasError ? styles.error : "",
            value && value.length > 0 ? "ui-icon-close" : icon,
          ].join(" ")}
        />
      )}
    </div>
  );
};

export default SearchInput;
